// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-message-item-xKfiOI{align-items:center;width:100%;margin-bottom:8px;display:flex;position:relative}.suggestion-message-item-xKfiOI .no-icon-RMwhvv{position:absolute;right:16px}.suggestion-message-item-xKfiOI .semi-input-textarea-wrapper{padding-right:48px}.tooltip-wrapper-lP4S4t{position:relative}.icon-button-16-_M6k5J:hover{border-radius:4px}.icon-button-16-_M6k5J .semi-button.semi-button-size-small{height:16px;padding:1px}.icon-no-disabled-luT0gJ{color:rgba(29,28,35,.2)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestion-message-item": `suggestion-message-item-xKfiOI`,
	"suggestionMessageItem": `suggestion-message-item-xKfiOI`,
	"no-icon": `no-icon-RMwhvv`,
	"noIcon": `no-icon-RMwhvv`,
	"tooltip-wrapper": `tooltip-wrapper-lP4S4t`,
	"tooltipWrapper": `tooltip-wrapper-lP4S4t`,
	"icon-button-16": `icon-button-16-_M6k5J`,
	"iconButton16": `icon-button-16-_M6k5J`,
	"icon-no-disabled": `icon-no-disabled-luT0gJ`,
	"iconNoDisabled": `icon-no-disabled-luT0gJ`
};
export default ___CSS_LOADER_EXPORT___;
